'use strict';
var elements = document.querySelectorAll('span.population');
var numbers = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var el = _step.value;
        var textData = el.textContent;
        var numberString = textData.split(',').join('');
        var number = +numberString;
        numbers.push(number);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var total = numbers.reduce(function(accum, current) {
    return accum + current;
}, 0);
var average = total / numbers.length;
document.querySelector('.average-population').textContent = average.toLocaleString();
document.querySelector('.total-population').textContent = total.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.f2aad40e.js.map
